import styles from './styles.module.scss'

import Button from '@/components/Button'

type IpAllowlistLockoutCardProps = {
  onRetry: () => void
  onSignOut: () => void
}

const IpAllowlistLockoutCard = ({ onRetry, onSignOut }: IpAllowlistLockoutCardProps) => {
  return (
    <>
      <h2 className={styles.title}>{"Your network isn't allowed"}</h2>
      <p className={styles.lockoutSubtitle}>
        Your admin only allows Wispr on approved networks. Switch networks or contact your admin.
      </p>
      <div className={styles.lockoutActions}>
        <Button type="dark" title="Retry" onClick={onRetry} className={styles.lockoutActionButton} />
        <Button type="dark" title="Sign out" onClick={onSignOut} className={styles.lockoutActionButton} />
      </div>
    </>
  )
}

export default IpAllowlistLockoutCard
